import { get } from 'lodash';
import { FONT_FAMILY } from '@utils/constants';
import { MANUAL_ALERT_SERIES } from '../../utils/constants';
import { createAlertSummary } from '@components/alert-panel/ManualAlert/hooks/utils';

// chart markLine format
export const formatAlertEvent = (event, alert, selectedEventId) => {
  const fomattedEvent = {
    event,
    alert,
    // markline point
    xAxis: event.time,
    // for tooltip
    info: createAlertSummary(event, alert),
    lineStyle: event.id === selectedEventId ? { color: '#FF6347', opacity: 1 } : {},
  };
  return fomattedEvent;
};

export const markLineOptions = (data) => {
  return {
    symbol: ['none', 'diamond'],
    lineStyle: {
      width: 2,
      type: 'solid',
      color: '#CE6940',
      opacity: 0.5,
    },
    label: {
      show: false,
    },
    emphasis: {
      disabled: true,
    },
    tooltip: {
      trigger: 'item',
      // position: ['5%', '10%'],
      borderWidth: 0,
      confine: true,
      textStyle: {
        fontFamily: FONT_FAMILY,
        // width: 100,
        // height: 40,
        fontSize: 12,
        overflow: 'break',
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        borderRadius: 4,
      },
      formatter: ({ data }) => {
        const { info } = data;
        return `
          <strong> Manual Alert: ${info.name} </strong> <br/>
          <i style="color: #4a4a4a;">Filter: ${info.filterName}</i> <br/>
          <i style="color: #4a4a4a;">Condition: ${info.rule} | Threshold: ${info.threshold}</i> <br/>
          <i style="color: #4a4a4a;">Time Range: ${info.timeRange}</i> <br/>
          ${info.priority ? `<i style="color: #4a4a4a;">CoolDown: ${info.cooldown} | Priority: ${info.priority} </i>` : ''}`;
      }, // workaround until we can replace alert apis
    },
    data: data,
  };
};

export const getAlertsOption = ({ events, alerts, selectedEvent }, params = {}) => {
  const selectedEventId = get(selectedEvent, 'id', null);
  const formattedEvents = events.map((event) =>
    formatAlertEvent(event, alerts[event.alertId], selectedEventId),
  );

  return {
    id: MANUAL_ALERT_SERIES,
    name: 'Manual alerts',
    type: 'line',
    markLine: markLineOptions(formattedEvents),
    xAxisIndex: 0,
    yAxisIndex: 0,
    ...params,
  };
};
